import templateUrl from "webmodals/model-prompt.htm";
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import open from "webmodals/open";

export class ModelPrompt {
  constructor() {
    this.seed = {};
  }
  //helpers
  _open(model, action, ctaTitle) {
    let modalOptions = this.getModalOptions(model, action, ctaTitle);
    console.info("ModelPrompt._open", {
      model,
      action,
      ctaTitle,
      modalOptions,
    });
    let modalInstance = open(modalOptions);
    modalInstance.result.then(this.onClosed, this.onDismissed);
    return modalInstance.result;
  }
  getModalOptions(model, action) {
    return {
      templateUrl,
      size: this.getModalSize(model, action),
      resolve: {
        options: () => ({
          prompt: this,
          request: Object.assign({}, this.seed, model),
          action: action,
          queryUrl: this.getQueryUrl(model, action),
          commandUrl: this.getCommandUrl(model, action),
          bodyTemplateUrl: this.getModalBodyTemplateUrl(model, action),
          footerLeftTemplateUrl: this.getModalFooterLeftTemplateUrl(
            model,
            action
          ),
          title: this.getTitle(model, action),
          subTitle: this.getSubTitle(model, action),
        }),
      },
      bindToController: true,
      controller: this.getController(model, action),
      controllerAs: "$ctrl",
    };
  }
  getTitle(model, action) {
    return action + " this object...";
  }
  getSubTitle(model, action) {
    return action + " this object...";
  }
  getQueryUrl(model, action) {
    return null;
  }
  getCommandUrl(model, action) {
    return null;
  }
  getModalSize(model, action) {
    return "md";
  }
  getModalBodyTemplateUrl(model, action) {
    return null;
  }
  getModalFooterLeftTemplateUrl(model, action) {
    return null;
  }
  getController(model, action) {
    return ModelPromptController;
  }

  //validate(model, action) {
  //	return model;
  //}

  mapModel(model, action) {
    return model;
  }
  //methods
  add(model) {
    return this._open(model, "Create");
  }
  start(model) {
    return this._open(model, "Start");
  }
  edit(model) {
    return this._open(model, "Update");
  }
  delete(model) {
    return this._open(model, "Delete");
  }
  //events
  onClosed() {}
  onDismissed() {}
  onInit($ctrl) {}
}

export class ModelPromptController {
  constructor(options) {
    let $ctrl = this;
    basicController($ctrl);
    console.debug("ModelPromptController", { options, $ctrl });
    Object.assign($ctrl, options);
    $ctrl.query = new AutoQuery({
      url: options.queryUrl,
      autoLoad: options.action !== "Create" && options.queryUrl,
      onLoaded: (args) =>
        $ctrl.prompt.onLoaded(Object.assign(this.request, args.first)),
    });
    $ctrl.bus = $ctrl.query.bus;
    $ctrl.valid = true;
  }
  dismiss(reason) {
    let $ctrl = this;
    $ctrl.$dismiss(reason);
  }
  close(reason) {
    let $ctrl = this;
    $ctrl.$close(reason);
  }
  submit() {
    let $ctrl = this;
    $ctrl.bus.send($ctrl.commandUrl, $ctrl.prompt.mapModel($ctrl.request)).then(
      (r) => $ctrl.onSuccess(r),
      (r) => $ctrl.onFailed(r)
    );
    //$ctrl.prompt.validate($ctrl.request).then(function () {
    //	if ($ctrl.valid) {
    //		$ctrl.bus
    //			.send($ctrl.commandUrl, $ctrl.prompt.mapModel($ctrl.request))
    //			.then(r => $ctrl.onSuccess(r), r => $ctrl.onFailed(r));
    //	}
    //});
  }
  
  findRetailers(val) {
    const $ctrl = this;
    let url = `QueryRetailersSearch.json?Take=5&Status=Active&Search=${val}&OrderBy=CompanyName`; //
    console.log("QueryRetailersSearch.$item", url);
    return $ctrl.bus.send(url).then((res) => res.data.results);
  }
  selectRetailer(val) {
    const $ctrl = this;
    $ctrl.request.customer = val;
    var retailerQuery = new AutoQuery({
      url: "QueryRetailers.json?Id=" + $ctrl.request.customer.id,
      orderBy: "CompanyName",
      autoLoad: true,
      onLoaded(args) {
        $ctrl.request.customer = args.first;
        $ctrl.request.customerId = $ctrl.request.customer.id;
      },
    });
  }

  onSuccess(res) {
    let $ctrl = this;
    //Object.assign(this.request, res.data);
    $ctrl.$emit(`${$ctrl.commandUrl.split(/\W/)[0]}Success`, res, $ctrl);
    $ctrl.$close(res.data, $ctrl.request);
  }

  onFailed(res) {
    this.$emit(`${this.commandUrl.split(/\W/)[0]}Error`, res, this);
  }

  isBusy() {
    return this.query.bus.activeCalls.length + this.bus.activeCalls.length;
  }
}

export class ModelPromptComponent {
  constructor(promptName) {
    //console.debug("ModelPromptComponent", promptName, this);
    this.controller.$inject = [promptName];
    this.bindings = {
      prompt: "=",
      onClosed: "&", // ? optional
      onDismissed: "&", // ? optional
    };
  }
  onLoaded(model) {}
  controller(prompt) {
    let $ctrl = this;
    $ctrl.prompt = (name, request, modalOptions) => {
      console.warn("$ctrl.prompt", name, request, modalOptions);
      prompt[name](request, modalOptions).then(
        ($args) =>
          $ctrl.onClosed({
            $args,
            $prompt: $ctrl.prompt,
            $action: $ctrl.prompt.action,
          }),
        ($args) =>
          $ctrl.onDismissed({
            $args,
            $prompt: $ctrl.prompt,
            $action: $ctrl.prompt.action,
          })
      ); //optional
    };
    console.debug("ModelPromptController", prompt, this);
  }
}

export default ModelPrompt;
